module.exports = __webpack_public_path__ + "media/img/pages/profile/kpmg ger 12-1506f0b24d0b282fc984a7a9f0f7f37e.jpg";